import React, { useState, useEffect } from 'react';
import {
  Form, Input, Button, Icon,
} from 'semantic-ui-react';

const ProjectSearchInput = ({ query, setQuery }) => {
  const [input, setInput] = useState(query);

  useEffect(() => {
    setInput(query);
  }, [query]);

  return (
    <Form onSubmit={() => setQuery(input)}>
      <Input
        fluid
        placeholder="Search all team projects"
        value={input}
        onChange={(e, { value }) => setInput(value)}
        label={(<Button icon><Icon name="search" /></Button>)}
        labelPosition="right"
      />
    </Form>
  );
};

export default ProjectSearchInput;
